module.exports = __webpack_public_path__ + "static/pinkmummyme5-e65a613a7c4889fd2569be4070c2f69d.png";